<template>
  <ul class="table-body">
    <li class="table-title">
      <div class="title-item">酒店及房型</div>
      <div class="title-item">规格</div>
      <div class="title-item">预订日期</div>
      <div class="title-item">价格</div>
      <div class="title-item">入住人</div>
    </li>
    <li class="list-item" v-for="(item, index) in itemList" :key="index">
      <div class="title-item">
        <p>{{ item.hotelName }}</p>
        <p>{{ item.hotelType }}</p>
      </div>
      <div class="title-item">{{item.sellType | measureType}}</div>
      <div class="title-item">{{ $moment(item.startDate).format('YYYY-MM-DD') }}至{{ $moment(item.endDate).format('YYYY-MM-DD') }}</div>
      <div class="title-item">¥{{item.price}}</div>
      <div class="title-item">
        <p>{{ item.customerName }}</p>
        <p>{{ item.gender === '1' ? '男' : '女'}}</p>
      </div>
      <!-- <div class="title-item cancel" @click="cancel">
          {{cancelStatu || isDeleted===1? '已取消':'取消订单'}}
      </div> -->
    </li>
  </ul>
</template>

<script>
import http from '@/utils/http'
export default {
  name: "orderItem",
  props: {
    itemList: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      cancelStatus: false
    }
  },
  methods: {
    async cancel() {
      const res = await  http.post(`/renren-fast/app/audienceCenter/update/OrderStatus/${this.itemList.id}`)
      if(res.code===0){
          this.$alert('取消订单成功')
          this.cancelStatus = true
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.table-body {
  border-top: 1px solid #dcdcdc;
  border-bottom: 1px solid #dcdcdc;
  font-size: 21px;
  color: #4c4c4c;

  >li {
    display: flex;

    >div {
      text-align: center;

      &:nth-of-type(1) {
        width: 30%;
      }

      &:nth-of-type(2) {
        width: 10%;
      }

      &:nth-of-type(3) {
        width: 25%;
      }

      &:nth-of-type(4) {
        width: 15%;
      }

      &:nth-of-type(5) {
        width: 15%;
      }
    }
  }

  .table-title {
    color: #a4a4a4;
    height: 50px;
    line-height: 50px;
    border-bottom: 1px solid #dcdcdc;
  }

  .list-item {
    height: 90px;
    border-bottom: 1px dashed #dcdcdc;

    >div {
      &:nth-of-type(1), &:nth-of-type(3), &:nth-of-type(5) {
        padding-top: 10px;
      }

      &:nth-of-type(2), &:nth-of-type(4), &:nth-of-type(6){
        line-height: 90px;
      }
    }
  }
}
.cancel{
    color: #2852a6
}
@media screen and (min-width: 800px) {
  .table-body {
    border-top: 1px solid #dcdcdc;
    border-bottom: 1px solid #dcdcdc;
    font-size: 16px;
    color: #4c4c4c;

    >li {
      display: flex;

      >div {
        text-align: center;

        &:nth-of-type(1) {
          width: 30%;
        }

        &:nth-of-type(2) {
          width: 15%;
        }

        &:nth-of-type(3) {
          width: 25%;
        }

        &:nth-of-type(4) {
          width: 15%;
        }

        &:nth-of-type(5) {
          width: 15%;
        }
      }
    }

    .table-title {
      color: #a4a4a4;
      height: 40px;
      line-height: 40px;
      border-bottom: 1px solid #dcdcdc;
    }

    .list-item {
      height: 75px;
      border-bottom: 1px dashed #dcdcdc;

      >div {
        &:nth-of-type(1), &:nth-of-type(3), &:nth-of-type(5) {
          padding-top: 10px;
        }

        &:nth-of-type(2), &:nth-of-type(4) {
          line-height: 50px;
        }
      }
    }
  }
}
</style>
